/* eslint-disable max-lines-per-function */
import { ReactElement } from 'react';

import { Bean, FieldControllerProps } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableColumnConfiguration } from '@dreryk/react-components';

import { useColumns, useValidation } from './DiagnosesInteractiveTable.hooks';
import { DiagnosesTableBean } from './DiagnosesInteractiveTable.types';

type DiagnosesInteractiveTableProps<TABLE_BEAN extends DiagnosesTableBean> = FieldControllerProps<
   `${string}.value`,
   DiagnosesTableBean[]
> & {
   readonly header: ReactElement;
   readonly columns?: InteractiveTableColumnConfiguration<TABLE_BEAN>[];
};

export const DiagnosesInteractiveTable = <TABLE_BEAN extends DiagnosesTableBean>(
   props: DiagnosesInteractiveTableProps<TABLE_BEAN>
): JSX.Element => {
   return (
      <InteractiveTable<TABLE_BEAN, Bean>
         testId={'diagnoses'}
         name={props.name}
         register={props.register}
         validation={useValidation()}
         columns={useColumns(props.columns)}
         header={props.header}
         autoScroll={'start'}
      />
   );
};
